export default function CreditCardIcon({ className="", onClick=null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M418.13,103.03H81.87c-8.2,0-14.87,6.67-14.87,14.87v248.21c0,8.2,6.67,14.87,14.87,14.87h336.27c8.2,0,14.87-6.67,14.87-14.87V117.9c0-8.2-6.67-14.87-14.87-14.87ZM406.2,129.83v48.78H93.8v-48.78h312.4ZM406.2,354.17H93.8v-88.96l-1.15-1.15h1.15v-60.46h312.4v150.56Z"/>
      <rect xmlns="http://www.w3.org/2000/svg" x="137.38" y="263.66" width="77.96" height="47.64" />
    </svg>
  );
}
